import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Globals} from '../../../globals';

@Component({
  selector: 'app-insurance-no-fee-schedule-dialog',
  templateUrl: './insurance-no-fee-schedule-dialog.component.html',
  styleUrls: ['./insurance-no-fee-schedule-dialog.component.scss']
})

export class InsuranceNoFeeScheduleDialogComponent implements OnInit{

  isLoading: boolean = false;
  useUCR: boolean = false;
  organizationName: string = '';

  constructor(
    public dialogRef: MatDialogRef<InsuranceNoFeeScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: Globals,
  ) {  }

  async ngOnInit() {
    if (this.data.OrganizationName) {
      this.organizationName = this.data.OrganizationName;
    }
  }

  selectUCR() {
    this.useUCR = true;
    this.dialogRef.close(this.useUCR);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
